<template>
  <div class="profile-account-change-password text-center">
    <TopMenu
      :title="$t('PROFILE.CHANGE_PASSWORD.PAGE_LABEL')"
      back-to="/dashboard/profile"
      dark-background/>
    <div class="container-fluid content">
      <form
        class="form-change-password"
        @submit.prevent="save">
        <div class="row-item-transparent-with-border mt-3 mb-4 text-left">
          <h3>{{ $t('PROFILE.CHANGE_PASSWORD.HEADER') }}</h3>
        </div>
        <FormInput
          v-validate="'required'"
          :name="$t('PROFILE.CHANGE_PASSWORD.OLDPASSWORD')"
          v-model="localChangePassword.oldPassword"
          :placeholder="$t('PROFILE.CHANGE_PASSWORD.OLDPASSWORD')"
          required
          class="mb-5"
          type="password"/>
        <div class="row-item-transparent-with-border mb-4 text-left">
          <h3>{{ $t('PROFILE.CHANGE_PASSWORD.HEADER2') }}&nbsp;
            <span>
              <i
                variant="primary"
                class="far fa-question-circle pr-2"
                @click="show = !show"/>
          </span></h3>
        </div>
        <password-rules :show="show" />
        <FormInput
          v-validate="'required'"
          ref="password"
          :name="$t('PROFILE.CHANGE_PASSWORD.NEWPASSWORD')"
          v-model="localChangePassword.newPassword"
          :placeholder="$t('PROFILE.CHANGE_PASSWORD.NEWPASSWORD')"
          required
          class="mb-3"
          type="password"/>
        <FormInput
          v-validate="'required|confirmed:password'"
          :name="$t('PROFILE.CHANGE_PASSWORD.CONFIRMPASSWORD')"
          v-model="localChangePassword.confirmPassword"
          :placeholder="$t('PROFILE.CHANGE_PASSWORD.CONFIRMPASSWORD')"
          required
          class="mb-5"
          type="password"/>
        <ActionButton
          type="submit"
          class="btn btn-lg btn-primary btn-block mt-3 mb-3">{{ $t("PROFILE.CHANGE_PASSWORD.SAVE_BUTTON") }}</ActionButton>
      </form>
    </div>
    <BottomMenu />
  </div>
</template>

<script>
import TopMenu from '@/components/Menu/TopMenu';
import BottomMenu from '@/components/Menu/BottomMenu';
import TextLink from '@/components/Utils/TextLink';
import ActionButton from '@/components/Actions/ActionButton';
import FormInput from '@/components/Forms/FormInput';
import PasswordRules from '@/components/Utils/PasswordRules';

export default {
  name: 'ProfileChangePassword',
  components: {
    ActionButton,
    TextLink,
    TopMenu,
    BottomMenu,
    FormInput,
    PasswordRules,
  },
  data() {
    return {
      localChangePassword: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      },
      show: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    save() {
      this.$validator.validate().then(() => {
        if (this.$validator.errors.items.length > 0) {
          this.$store.commit('alerts/setAlert', {
            msg: this.$t(
              `VALIDATION.${
                this.$validator.errors.items[0].rule.toUpperCase()}`,
              [this.$validator.errors.items[0].field],
            ),
          });
        } else {
          this.$store
            .dispatch('member/changePassword', this.localChangePassword)
            .then(() => {
              this.$store.commit('alerts/setAlert', {
                msg: 'PROFILE.CHANGE_PASSWORD.CONFIRMATION_MESSAGE',
              });
              this.localChangePassword = {
                oldPassword: '',
                newPassword: '',
                confirmPassword: '',
              };
            });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
div {
  &.profile-account-change-password {
    height: 100%;
  }
  &.content {
    padding-top: $top-menu-height;
    padding-bottom: $bottom-menu-height;
    background-color: $base;
    min-height: 100%;
  }
}
</style>
